import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { useQueryState } from 'nuqs'
import useQuerySmsAutoLogs from '../../api/hooks/useQuerySmsAutoLogs'
import SmsAutoLogsTable from '../SmsAutoLogsTable'
import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'
import { SmsAutoLogStatus } from '@/modules/transaction/types'

export default function SmsAutoLogsListing() {
	const { pageSize, currentPage } = useTablePagination()
	const { dateFilter } = useDateFilter()
	const [accountNumber] = useQueryState('accountNumber')
	const [amount] = useQueryState('amount')
	const [activeTab, setActiveTab] = useQueryState('tab', {
		defaultValue: 'all',
	})

	const isPendingTab = activeTab === 'pending'

	const PENDING_STATUSES = [
		SmsAutoLogStatus.UNMATCHED,
		SmsAutoLogStatus.PROCESSING,
	]

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		accountNumber: accountNumber || undefined,
		amount: amount ? Number(amount) : undefined,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		sortByCreatedAt: 'desc' as const,
		status: isPendingTab ? PENDING_STATUSES : undefined,
	}

	const { data, refetch, isLoading } = useQuerySmsAutoLogs(payload)

	const logsList = data?.data || []
	const totalLogs = data?.total || 0

	const pendingCountPayload = {
		take: 1,
		skip: 0,
		status: PENDING_STATUSES,
	}
	const { data: pendingCountData } = useQuerySmsAutoLogs(pendingCountPayload)
	const pendingCount = pendingCountData?.total || 0

	return (
		<div className="space-y-4 px-4 sm:px-0">
			{/* Header Section */}
			<div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
				<div className="space-y-3 sm:space-y-4">
					<Heading
						title="ประวัติ SMS แจ้งเตือน"
						description="รายการ SMS แจ้งเตือนทั้งหมด"
					/>
				</div>

				{/* Date Controls */}
				<div className="flex flex-col gap-3 sm:items-end sm:gap-4">
					<DateRangePicker />
					<DateRangeButtons />
				</div>
			</div>

			{/* Tab Bar */}
			<div className="flex gap-1 border-b">
				<button
					className={`px-4 py-2 text-sm font-medium transition-colors ${
						isPendingTab
							? 'border-b-2 border-primary text-primary'
							: 'text-muted-foreground hover:text-foreground'
					}`}
					onClick={() => setActiveTab('pending')}
				>
					รอดำเนินการ
					{pendingCount > 0 && (
						<span className="ml-1.5 rounded-full bg-primary px-1.5 py-0.5 text-xs text-primary-foreground">
							{pendingCount}
						</span>
					)}
				</button>
				<button
					className={`px-4 py-2 text-sm font-medium transition-colors ${
						!isPendingTab
							? 'border-b-2 border-primary text-primary'
							: 'text-muted-foreground hover:text-foreground'
					}`}
					onClick={() => setActiveTab('all')}
				>
					รายการทั้งหมด
				</button>
			</div>

			<Separator className="my-4 sm:my-6" />

			{/* Table Section */}
			<SmsAutoLogsTable
				data={logsList}
				total={totalLogs}
				onRefresh={refetch}
				isLoading={isLoading}
			/>
		</div>
	)
}
